import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

/**
 *  Service de gestion des conditions générales de vente
 */
@Injectable()
export class CgvvalidService {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    this.w_baseUrl = this.s_global.pathAPI + "/cgvvalid";
  }

  /**
   * Fonction de recuperation de CGV par token lorsque l'utilisateur n'a pas validés ses CGV pour eviter une deconnexion
   * Parametres : token de session
   * Retour : json avec tiers chef de grappe
   */
  public proc_getCgvByToken(token: string): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getCgvByToken`,
      token,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de la liste des CGV validées une fois connecté
   * Retour : json avec liste des tiers chef de grappe, possedant les CGV a afficher
   */
  public proc_getListCgvByToken(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getListCgvByToken`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de validation d'une CGV pour l'utilisateur actif lorsque l'utilisateur n'a pas validés ses CGV pour eviter une deconnexion
   * Parametres : CGV validées, token de l'utilisateur
   * Retour : json avec liste des tiers chef de grappe, possedant les CGV a afficher
   */
  public proc_validCGV(CGVValide: string, token: string): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/validCGV`,
      JSON.stringify({ CGVValide: CGVValide, token: token }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'une CGV sur la BDD
   * Parametres : CGV
   */
  public proc_add(Cgvvalid: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify(Cgvvalid),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/cgvvalid.service.ts